import { DisabledPrompt, Link } from "@bcm-dev/bcms-vite";
import { CustomModalContent, EDEStatementsCustomModal } from "components/custom-ui/CustomModal";
import { FormContainer, FormRowView } from "components/shared";
import "./styles.css";
import "./mobile.css";


/**
 * @function EDEStatementModal
 * @return {React.Component}
 * @exported true
 * @description The main component for the EDEStatementModal
 */
export default function EDEStatementModal(props) {
    const data = props.data.data ?? {};
    const ui = props.data.ui ?? {};
    const account = data.account ?? {};

    return (
        <EDEStatementsCustomModal id="EDEStatementModal" title={ `View Statement - ${ account.name } - ${ account.number }`}
         className="ede-statement-modal" dataPoint="EDE_Statement_Modal">
            <CustomModalContent>
                <FormContainer>
                    <FormRowView>
                        <DisabledPrompt>
                            <Link>
                                <span data-point="EDE_Statements_View_PDF">{ `View PDF` }</span>
                            </Link>
                        </DisabledPrompt>
                    </FormRowView>
                </FormContainer>
            </CustomModalContent>
        </EDEStatementsCustomModal>
    );
}
